import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import NoStoresAlert from "./NoStoresAlert.js";
const NoStoresAlertContainer = () => {
  const { getLabel } = useIntl();
  const labels = React.useMemo(
    () => ({
      message: getLabel("appointments.component.storeFinder.noStoresAlert.message")
    }),
    [getLabel]
  );
  return /* @__PURE__ */ React.createElement(NoStoresAlert, { labels });
};
export {
  NoStoresAlertContainer as default
};
//# sourceMappingURL=NoStoresAlertContainer.js.map
